var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("backer-center-header", {
    scopedSlots: _vm._u([
      {
        key: "prefix",
        fn: function () {
          return [
            _c("backer-center-thumbnail", {
              attrs: {
                "image-url": _vm.imageUrl,
                name: _vm.name,
                url: _vm.formattedYourPledgeUrl,
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "default",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "_flexcol _jc-c" },
              [
                _c(
                  "base-text",
                  {
                    attrs: {
                      as: "a",
                      href: _vm.formattedYourPledgeUrl,
                      level: "b1",
                      "data-qa": "project-order-card-projectName",
                    },
                  },
                  [_vm._v(_vm._s(_vm.name))]
                ),
                _vm._v(" "),
                _c(
                  "localize",
                  {
                    staticClass: "_tc--light gfu-bt--caption",
                    attrs: { tag: "div", resource: _vm.captionResource },
                  },
                  [
                    _c(
                      "span",
                      {
                        attrs: {
                          "format-key": "0",
                          "data-qa": "project-order-card-publicOrderID",
                        },
                      },
                      [_vm._v(_vm._s(_vm.orderPublicID))]
                    ),
                    _vm._v(" "),
                    _c("span", { attrs: { "format-key": "1" } }, [
                      _vm._v(_vm._s(_vm.formattedCreatedAt)),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "suffix",
        fn: function () {
          return [
            _c(
              "base-text",
              {
                staticClass: "_as-fs",
                attrs: {
                  level: "b1",
                  "data-qa": "project-order-card-TotalAmount",
                },
              },
              [_vm._v(_vm._s(_vm.formattedTotalAmount))]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }